import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';
import Image from 'src/components/Image';

const propTypes = {
  id: PropTypes.string,
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const DeVersion = ({ availableLanguages }) => {
  return (
    <>
      <h4 id='datenschutzerklärung-für-bewerber'>
        Datenschutzerklärung für Bewerber (weltweit)
      </h4>

      <p>Verfügbare Sprachen:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />

      <p>Gültigkeitsdatum: 1. Februar 2024</p>
      <p>
        Bei Plaid sind wir uns der Bedeutung von Datenschutz und Transparenz
        bewusst. Der Zweck dieser Datenschutzerklärung für Bewerber
        („Erklärung”) besteht darin, zu erklären, wie Plaid Inc. und seine
        Tochtergesellschaften einschließlich Plaid Financial Ltd. und Plaid,
        B.V. (als „Plaid”, „wir”, „unser” oder „uns” zusammengefasst)
        personenbezogene Daten und Informationen von und über potenzielle
        Bewerber („Sie” oder „Ihr”) für Positionen bei Plaid
        („Bewerberinformationen”) erheben, verwenden und weitergeben.
      </p>
      <p>
        Wenn Sie Ihren Lebenslauf oder andere Bewerberinformationen über unsere
        Website einreichen, beachten Sie bitte, dass wir auch Daten über Sie in
        Verbindung mit Ihrem Zugriff auf oder Ihrer Nutzung der Website von
        Plaid erfassen und verarbeiten können. Zusätzliche Informationen zu
        unserer Verwendung Ihrer Daten finden Sie in unserer
        Datenschutzerklärung. Weitere Informationen über die Arten von Cookies,
        die wir auf unserer Website verwenden, warum wir sie verwenden und wie
        Sie die Verwendung von Cookies kontrollieren oder einschränken können,
        finden Sie in unserer{' '}
        <Link href='#cookie-richtlinie'>
          <a>Cookie-Richtlinie</a>
        </Link>
        .
      </p>
      <p>
        <em>Zum Abschnitt springen:</em>
      </p>
      <p>
        <Link href='#unsere-datenpraxis-datenschutzerklärung-für-bewerber'>
          <a data-smooth-scroll data-offset='80'>
            Unsere Datenpraxis
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#informationen-die-wir-erfassen-datenschutzerklärung-für-bewerber'>
              <a>Informationen, die wir erfassen</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wie-wir-ihre-informationen-nutzen-information-datenschutzerklärung-für-bewerber'>
              <a>Wie wir Ihre Informationen nutzen</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#an-wen-wir-ihre-informationen-weitergeben-datenschutzerklärung-für-bewerber'>
              <a>An wen wir Ihre Informationen weitergeben</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#unsere-rechtsgrundlagen-für-die-verarbeitung-datenschutzerklärung-für-bewerber'>
              <a>
                Unsere Rechtsgrundlagen für die Verarbeitung (nur Bewerber aus
                dem Vereinigten Königreich und dem EWR)
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#unsere-aufbewahrungspraktiken-datenschutzerklärung-für-bewerber'>
              <a>Unsere Aufbewahrungspraktiken</a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#andere-hinweise-datenschutzerklärung-für-bewerber'>
          <a data-smooth-scroll data-offset='80'>
            Andere Hinweise
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#internationale-datenübermittlung-datenschutzerklärung-für-bewerber'>
              <a>Internationale Datenübermittlung</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#datenschutzrechte-von-bewerbern-in-kalifornien'>
              <a>Datenschutzrechte von Bewerbern in Kalifornien</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#datenschutzrechte-von-bewerbern-datenschutzerklärung-für-bewerber'>
              <a>Datenschutzrechte von Bewerbern im UK, im EWR und in Kanada</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#anderungen-an-dieser-erklärung-datenschutzerklärung-für-bewerber'>
              <a>Änderungen an dieser Erklärung</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#kontaktaufnahme-mit-plaid-datenschutzerklärung-für-bewerber'>
              <a>Kontaktaufnahme mit Plaid </a>
            </Link>
          </p>
        </li>
      </ul>
      <br />
      <br />

      <h4 id='unsere-datenpraxis-datenschutzerklärung-für-bewerber'>
        Unsere Datenpraxis
      </h4>

      <h5 id='informationen-die-wir-erfassen-datenschutzerklärung-für-bewerber'>
        Informationen, die wir erfassen
      </h5>
      <p>
        Wir erfassen Bewerberinformationen, die von (1) Ihnen wie insbesondere
        über Plaids Karriereseite (zugänglich unter https://plaid.com/careers/),
        (2) Dritten wie etwa Anbietern von Hintergrundüberprüfungen,
        Rekrutierungsberatern oder professionellen Rekrutierungsagenturen oder
        (3) Plaid selbst im Wege von Bewerberrecherchen geliefert bzw. beschafft
        werden. Wir können auch Bewerberinformationen ableiten, indem wir ein
        Profil erstellen, das Ihre Beschäftigungspräferenzen, Eigenschaften,
        Verhaltensweisen, Intelligenz, Fähigkeiten und Eignungen widerspiegelt,
        wie z. B. mithilfe von Notizen, die im Rahmen des Interviewprozesses
        angefertigt werden.
      </p>
      <p>
        Wir erfassen die folgenden Kategorien von Bewerberinformationen über
        Bewerber, die wir für Stellen in Betracht ziehen:
      </p>
      <ul>
        <li>
          <p>
            <u>Identifikatoren und Kontaktinformationen</u>, einschließlich
            Ihres vollständigen Namens, Ihrer Adresse, Telefonnummer,
            E-Mail-Adresse oder anderer Kontaktinformationen,
          </p>
        </li>
        <li>
          <p>
            <u>berufliche oder beschäftigungsrelevante Informationen</u>,
            einschließlich Informationen in Ihrem Lebenslauf, Ihres beruflichen
            Werdegangs, Zeugnissen, beruflicher Zulassungen und anderer
            Erfahrungen sowie Kontaktdaten Ihres ehemaligen/derzeitigen
            Arbeitgebers (wenn diese Angaben Ihre personenbezogenen Daten
            enthalten),
          </p>
        </li>
        <li>
          <p>
            <u>Ausbildungsinformationen</u>, einschließlich Informationen über
            Ihre Abschlüsse und Schulungen, Zeugnissen und Studienleistungen,
          </p>
        </li>
        <li>
          <p>
            <u>Informationen aus sozialen Netzwerken und dergleichen</u>, wie z.
            B. Informationen in sozialen Medien und öffentlichen Profilen,
            einschließlich URLs in Verbindung mit Ihren LinkedIn-, Twitter-,
            GitHub- und Portfolio-Profilen sowie Ihrer persönlichen Website,
          </p>
        </li>
        <li>
          <p>
            <u>
              in bestimmten Regionen (wie den USA) können wir demografische und
              andere sensible Informationen (z. B. Ethnie, Geschlecht,
              Veteranenstatus, Volkszugehörigkeit, sexuelle Orientierung und
              Behinderungsstatus) erfassen
            </u>
            ; und
          </p>
        </li>
        <li>
          <p>
            <u>andere von Ihnen eingereichte Informationen</u>, einschließlich
            zusätzlicher Informationen, die in einem Bewerbungsformular,
            Anschreiben oder einem anderen Arbeitsprodukt enthalten sind.
          </p>
        </li>
      </ul>

      <p>
        Wenn Ihre Bewerbung die nächste Runde erreicht, erfassen wir außerdem
        die folgenden Bewerberinformationen:
      </p>
      <ul>
        <li>
          <p>
            <u>
              Informationen, die im Rahmen des Interviewprozesses erfasst werden
            </u>
            , wie z. B. Notizen, die aus Ihrem Interview stammen (wenn sie Ihre
            personenbezogenen Daten enthalten), und personenbezogene Daten, die
            in Take-home-Projekten enthalten sind,
          </p>
        </li>
        <li>
          <p>
            <u>
              Informationen, die für die Planung Ihres Interviews erforderlich
              sind
            </u>
            , einschließlich Identifikatoren wie etwa Ihre Adresse, Ihre
            Known-Traveler-Nummer und etwaige Vielreisende-Angaben,
          </p>
        </li>
        <li>
          <p>
            <u>Audio- und visuelle Daten</u>, einschließlich Fotos für
            Arbeitsprofile und Sicherheitsaufzeichnungen in den Räumlichkeiten
            von Plaid,
          </p>
        </li>
        <li>
          <p>
            <u>
              Informationen zu elektronischen Netzwerkaktivitäten und
              Nutzungsdaten
            </u>
            , einschließlich Ihrer Nutzung von Plaid-Ausrüstung, -Geräten,
            -Software und anderen -Vermögenswerten,
          </p>
        </li>
        <li>
          <p>
            <u>Einzelheiten zu Beschäftigungserwartungen</u>, einschließlich Art
            der angestrebten Beschäftigung, Vergütungserwartungen,
            Umzugsbereitschaft und anderer beruflicher Präferenzen, soweit darin
            Ihre personenbezogenen Daten enthalten sind,
          </p>
        </li>
        <li>
          <p>
            <u>
              (sofern und soweit für eine bestimmte Rolle relevant)
              Informationen, die für die Vornahme einer Hintergrundüberprüfung
              erforderlich sind
            </u>
            , wie z. B. Informationen, die entweder von Ihnen selbst oder im
            Wege von Referenz- und Hintergrundüberprüfungen beschafft werden,
            vorbehaltlich möglicher weiterer Genehmigungen oder
            Benachrichtigungen, die nach geltendem Recht erforderlich und/oder
            zulässig sind, in der Regel im Wege der Vorlage eines amtlichen
            Führungszeugnisses (z. B. in den Niederlanden: Verklaring Omtrent
            Gedrag bzw.VOG), und
          </p>
        </li>
        <li>
          <p>
            <u>
              Informationen, die für die Aufnahme einer Beschäftigung
              erforderlich sind
            </u>
            , einschließlich Nachweis der Berechtigung, in einem bestimmten Land
            zu arbeiten (z. B. Reisepass oder Visum), demografische
            Informationen, wie etwa Ihr Geburtsdatum und -ort sowie Ihre
            Staatsbürgerschaft, Identifikatoren, wie etwa Ihre
            Sozialversicherungsnummer (sofern nach geltendem Recht
            vorgeschrieben und/oder zulässig), nationale Versicherungsnummer,
            andere behördlich ausgestellte Kennungen,
            Steueridentifikationsnummern und zugehörige steuerliche
            Informationen (sofern nach geltendem Recht vorgeschrieben und/oder
            zulässig) sowie Bankkontonummern und damit verbundene Informationen,
            Informationen zur Anspruchsberechtigung bezüglich Leistungen und
            sonstige Informationen, die Sie für Zwecke der Aufnahme des
            Beschäftigungsverhältnisses oder der Unterzeichnung eines
            Arbeitsvertrags liefern.
          </p>
        </li>
      </ul>

      <h5 id='wie-wir-ihre-informationen-nutzen-information-datenschutzerklärung-für-bewerber'>
        Wie wir Ihre Informationen nutzen
      </h5>
      <p>
        Wir verwenden die über Sie erfassten Bewerberinformationen, um Ihre
        Bewerbung für eine Anstellung zu bearbeiten und um gesetzliche
        Verpflichtungen zu erfüllen, denen wir im Zusammenhang mit Ihrer
        Bewerbung unterliegen, einschließlich der Überprüfung Ihrer
        Berechtigung, an einem bestimmten Standort zu arbeiten.
      </p>
      <p>
        Wir werden Ihre Bewerberinformationen ferner für die folgenden Zwecke
        verwenden:
      </p>
      <ul>
        <li>
          <p>
            <u>Verwaltung und Bearbeitung Ihrer Bewerbung</u>, einschließlich
            Überprüfung Ihrer Identifikation, Erfahrung und anderer von Ihnen
            übermittelten Informationen sowie, falls Ihre Bewerbung die nächste
            Runde erreicht, aller Interview- und
            Hintergrundüberprüfungsinformationen,
          </p>
        </li>
        <li>
          <p>
            <u>Kommunikation mit Ihnen zu Ihrer Bewerbung</u>, einschließlich
            Kontaktaufnahme mit Ihnen per Telefon, E-Mail oder
            Social-Media-Plattformen zu Ihrer Bewerbung und, falls Ihre
            Bewerbung die nächste Runde erreicht, Koordination von Interviews
            und Hintergrundüberprüfungen,
          </p>
        </li>
        <li>
          <p>
            <u>
              Beurteilung und Bewertung Ihrer Eignung für die Stelle, für die
              Sie sich beworben haben, oder für andere offene Stellen
            </u>
            , einschließlich der Überprüfung Ihrer Identifikation, Erfahrung und
            anderer von Ihnen übermittelten Informationen sowie, falls Ihre
            Bewerbung die nächste Runde erreicht, aller Interview- und
            Hintergrundüberprüfungsinformationen,
          </p>
        </li>
        <li>
          <p>
            <u>
              Vornahme von Referenz- und Hintergrundprüfungen, einschließlich
              Vorstrafenregister, im Rahmen Ihrer Bewerbung
            </u>
            , unter Berücksichtigung geltenden Rechts, einschließlich der
            Überprüfung Ihrer Identifikation, Erfahrung und anderer von Ihnen
            übermittelten Informationen sowie, falls Ihre Bewerbung die nächste
            Runde erreicht, aller Interview- und
            Hintergrundüberprüfungsinformationen,
          </p>
        </li>
        <li>
          <p>
            <u>
              Einhaltung maßgeblicher Gesetze und beschäftigungsrelevanter
              Auflagen
            </u>
            , einschließlich Überprüfung von Identifikationsinformationen sowie
            von Informationen, die zur Aufnahme einer Beschäftigung und für
            Zwecke wie etwa die Überprüfung Ihrer Fähigkeit, an einem bestimmten
            Standort auf legale Weise zu arbeiten, die Einrichtung von
            Gehaltsabrechnungen, Einbehaltungen und Sozialleistungen und die
            Befolgung gesetzlicher Meldepflichten benötigt werden,
          </p>
        </li>
        <li>
          <p>
            <u>Verbesserung unserer Einstellungsverfahren</u>, soweit nach
            geltendem Recht zulässig und nur in bestimmten Regionen (wie den
            USA), wie insbesondere im Wege der Erstellung von Analysen unter
            Verwendung von Bewerberinformationen, um sicherzustellen, dass wir
            eine Reihe unterschiedlicher Bewerber rekrutieren,
          </p>
        </li>
        <li>
          <p>
            <u>Versendung von Mitteilungen zu beruflichen Chancen an Sie</u>,
            darunter auch zu anderen Stellen, für die Sie möglicherweise
            geeignet sind, und
          </p>
        </li>
        <li>
          <p>
            <u>
              für andere mitgeteilte Zwecke, wenn wir über Ihre Einwilligung
              verfügen
            </u>
            .
          </p>
        </li>
      </ul>
      <p>
        Bitte beachten Sie, dass Ihre Bewerberinformationen Teil Ihrer
        Beschäftigungsakte und für Beschäftigungszwecke im Einklang mit
        geltendem Recht und allen maßgeblichen Datenschutzerklärungen für
        Mitarbeiter verwendet werden, wenn Sie eine Beschäftigung bei Plaid
        annehmen. Sollten Sie jedoch nicht für eine Stelle akzeptiert werden,
        können wir Ihre Bewerbung einschließlich relevanter
        Bewerberinformationen weiterhin aufbewahren, damit wir Sie für andere
        Karrieremöglichkeiten bei Plaid in Betracht ziehen können, sofern wir,
        falls dies nach maßgeblichen Gesetzen vorgeschrieben ist, Ihre vorherige
        Einwilligung für eine solche längere Aufbewahrung Ihrer
        personenbezogenen Daten eingeholt haben. Wenn Sie nicht möchten, dass
        Ihre Daten gespeichert werden, falls Ihnen keine Stelle angeboten wird,
        finden Sie in den folgenden Abschnitten Optionen, die Ihnen
        möglicherweise zur Verfügung stehen:{' '}
        <Link href='#datenschutzrechte-von-bewerbern-in-kalifornien'>
          <a>Datenschutzrechte von Bewerbern aus Kalifornien</a>
        </Link>{' '}
        und{' '}
        <Link href='#datenschutzrechte-von-bewerbern-datenschutzerklärung-für-bewerber'>
          <a>
            Datenschutzrechte von Bewerbern aus Großbritannien, dem EWR und
            Kanada
          </a>
        </Link>
        .
      </p>
      <p>
        Plaid verwendet Ihre personenbezogenen Daten nicht für eine
        automatisierte individuelle Entscheidungsfindung (einschließlich
        Profiling).
      </p>

      <h5 id='an-wen-wir-ihre-informationen-weitergeben-datenschutzerklärung-für-bewerber'>
        An wen wir Ihre Informationen weitergeben
      </h5>
      <p>
        Wir geben Ihre personenbezogenen Daten wie folgt oder wie ansonsten in
        dieser Erklärung beschrieben an andere weiter:
      </p>
      <ul>
        <li>
          <p>
            <u>
              zwischen Plaid und unseren Tochtergesellschaften und verbundenen
              Unternehmen
            </u>
            , da die spezifische Organisation, bei der Sie sich bewerben, Teil
            einer breiteren Gruppe von Unternehmen mit Hauptsitz in den
            Vereinigten Staaten und Niederlassungen in verschiedenen Ländern
            ist, die Personal- und IT-Systeme zur Bearbeitung Ihrer Bewerbung,
            Beurteilung Ihrer Eignung für die Rolle und Aufnahme einer
            Beschäftigungsbeziehung (falls zutreffend) teilen,
          </p>
        </li>
        <li>
          <p>
            <u>an unsere Datenverarbeiter und andere Dienstleister</u>,
            einschließlich Anbietern für Datenanalysen und
            Hintergrundüberprüfungen sowie Rekrutierungsagenturen, in Verbindung
            mit den Dienstleistungen, die sie für uns oder in unserem Auftrag
            ausführen. Soweit erforderlich sind diese Dienstleister, Partner
            oder Anbieter, die in unserem Namen handeln, vertraglich
            verpflichtet, angemessene technische und organisatorische Maßnahmen
            zum Schutz der Bewerberinformationen zu ergreifen und dürfen diese
            nur nach Anweisung verarbeiten,
          </p>
        </li>
        <li>
          <p>
            <u>
              an Strafverfolgungsbehörden, Regierungsbehörden, Aufsichtsbehörden
              und andere Drittanbieter
            </u>
            , wie z. B. Gerichte und andere Behörden, unabhängige externe
            Berater und interne Compliance- und Untersuchungsteams, wenn eine
            solche Weitergabe nach unserer Auffassung im Einklang mit
            maßgeblichen Gesetzen, Vorschriften oder gerichtlichen Verfügungen
            geschieht oder ansonsten von diesen vorgeschrieben ist,
          </p>
        </li>
        <li>
          <p>
            <u>
              in Verbindung mit oder während der Verhandlungen über einen
              Firmenzusammenschluss, einen Verkauf von Unternehmensteilen, eine
              Konsolidierung oder Umstrukturierung, eine Finanzierung oder eine
              Übernahme des gesamten oder eines Teils unseres Geschäfts durch
              oder in ein anderes Unternehmen
            </u>
            , soweit dies nach geltendem Recht zulässig ist,
          </p>
        </li>
        <li>
          <p>
            <u>soweit dies zum Schutz von Plaid</u>, erforderlich ist,
            einschließlich zur Begründung, Ausübung oder Abwehr potenzieller,
            drohender oder tatsächlicher Rechtsansprüche,
          </p>
        </li>
        <li>
          <p>
            <u>
              um Verträge mit Ihnen durchzusetzen oder wenn wir annehmen, dass
              Ihre Vorgehensweisen nicht mit unseren Richtlinien vereinbar sind
            </u>
            ;
          </p>
        </li>
        <li>
          <p>
            <u>
              um auf Forderungen zu reagieren, um unsere Rechte oder die Rechte
              eines Drittanbieters zu schützen, um die Sicherheit von Personen
              zu schützen oder um illegale Aktivitäten zu verhindern
            </u>
            ; oder
          </p>
        </li>
        <li>
          <p>
            <u>
              für jeden anderen mitgeteilten Zweck, sei es mit Ihrer Zustimmung
              oder auf Ihre Anweisung
            </u>
            .
          </p>
        </li>
      </ul>
      <p>
        Wir können außerdem aggregierte, anonymisierte oder de-identifizierte
        Informationen verwenden oder weitergeben, die ohne großen Aufwand nicht
        dazu verwendet werden können, um Sie zu identifizieren, soweit dies nach
        geltendem Recht zulässig ist.
      </p>

      <h5 id='unsere-rechtsgrundlagen-für-die-verarbeitung-datenschutzerklärung-für-bewerber'>
        Unsere Rechtsgrundlagen für die Verarbeitung (nur Bewerber aus dem
        Vereinigten Königreich und dem EWR)
      </h5>
      <p>
        Bei Bewerbern im Vereinigten Königreich (United Kingdom, „UK”) und im
        Europäischen Wirtschaftsraum („EWR”) hängt unsere Rechtsgrundlage für
        die Erfassung, Verwendung und Weitergabe von Bewerberinformationen von
        den betreffenden Daten und dem Kontext ab, in dem wir sie erfasst oder
        verarbeitet haben. Grundsätzlich gilt jedoch, dass wir
        Bewerberinformationen nur dann erfassen und verarbeiten werden, wenn:
      </p>
      <p>
        (a) wir die für uns geltenden rechtlichen Verpflichtungen erfüllen
        müssen (z. B. geltende Einwanderungs- und/oder Arbeitsgesetze und
        -vorschriften),
      </p>
      <p>
        (b) wir die Informationen benötigen, um unseren Verpflichtungen aus
        existierenden oder potenziellen Vereinbarungen mit Ihnen nachzukommen
        (wie z. B. einem Arbeitsvertrag oder einem Beschäftigungsangebot, wenn
        Sie für eine Beschäftigung in Betracht gezogen werden),
      </p>
      <p>
        (c) die Verarbeitung für unsere berechtigten Interessen erforderlich ist
        und Ihre Datenschutzinteressen oder Grundrechte und -freiheiten nicht
        überwiegen (z. B. um ein sicheres Arbeitsumfeld für alle unsere
        Teammitglieder und die Vertrauenswürdigkeit unserer Bewerber
        sicherzustellen und im Übrigen Ihr Bewerbung zu verwalten und zu
        bearbeiten oder mit Ihnen wegen Ihrer Bewerbung in Kontakt zu treten)
        und
      </p>
      <p>
        (d) wir Ihre diesbezügliche Einwilligung eingeholt haben (in Fällen, in
        denen Ihre Einwilligung wirklich freiwillig gegeben wird).
      </p>
      <p>
        Wenn es uns nach geltendem Recht erlaubt oder vorgeschrieben ist,
        spezielle Datenkategorien (z. B. ethnische Zugehörigkeit) zu erfassen
        und zu verarbeiten, werden diese Informationen von uns nur verarbeitet,
      </p>
      <ul>
        <li>
          <p>
            wenn wir dies vernünftigerweise tun müssen, um unseren gesetzlichen
            Verpflichtungen als potenzieller Arbeitgeber nachzukommen,
          </p>
        </li>
        <li>
          <p>
            wenn wir dies tun müssen, um über Ihre Arbeitsfähigkeit informiert
            zu sein,
          </p>
        </li>
        <li>
          <p>
            wenn wir dies tun müssen, um Ihre lebenswichtigen Interessen oder
            die einer anderen Person zu schützen (und wir nicht in der Lage
            sind, Ihre Einwilligung einzuholen), oder
          </p>
        </li>
        <li>
          <p>
            wenn Sie uns Ihre Einwilligung gegeben haben (in Fällen, in denen
            Ihre Einwilligung wirklich freiwillig gegeben wurde).
          </p>
        </li>
      </ul>

      <p>
        Soweit wir uns auf eine Einwilligung zur Erhebung und Verarbeitung von
        Bewerberinformationen stützen, haben Sie das Recht, Ihre Einwilligung zu
        verweigern oder jederzeit zu widerrufen, indem Sie uns per E-Mail an{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>{' '}
        kontaktieren. Der Widerruf Ihrer Einwilligung hat jedoch keinen Einfluss
        auf die Rechtmäßigkeit der Verarbeitung, die wir vor Ihrem Widerruf
        durchgeführt haben, und auch nicht auf die Verarbeitung Ihrer
        personenbezogenen Daten, die auf der Grundlage anderer rechtmäßiger
        Verarbeitungsgründe als der Einwilligung für andere Zwecke stattgefunden
        hat.
      </p>

      <h5 id='unsere-aufbewahrungspraktiken-datenschutzerklärung-für-bewerber'>
        Unsere Aufbewahrungspraktiken
      </h5>
      <p>
        Wir bewahren Bewerberinformationen nur so lange auf, wie es für die
        Erfüllung des Zwecks, für den sie erhoben und genutzt wurden,
        erforderlich ist, wie in dieser Erklärung beschrieben, es sei denn, eine
        längere Aufbewahrungsfrist ist nach geltendem Recht erforderlich oder
        zulässig. Wenn Sie eine Beschäftigung bei Plaid annehmen, werden Ihre
        Bewerberinformationen, wie bereits zuvor angesprochen, jedoch Teil Ihrer
        Beschäftigungsakte und für Beschäftigungszwecke im Einklang mit
        geltendem Recht und allen maßgeblichen Datenschutzerklärungen für
        Mitarbeiter verwendet.
      </p>

      <h4 id='andere-hinweise-datenschutzerklärung-für-bewerber'>
        Andere Hinweise
      </h4>

      <h5 id='internationale-datenübermittlung-datenschutzerklärung-für-bewerber'>
        Internationale Datenübermittlung
      </h5>
      <p>
        Wir sind international tätig und übermitteln Bewerberinformationen daher
        über internationale Grenzen hinweg, einschließlich aus dem UK, dem EWR
        und/oder aus Kanada in die Vereinigten Staaten, um sie zu verarbeiten
        und zu speichern. Soweit Bewerberinformationen aus dem UK oder dem EWR
        in Gebiete/Länder übermittelt werden, für die die EU-Kommission und/oder
        das britische Außenministerium (je nach Sachlage) nicht festgestellt
        hat, dass der Rechtsrahmen in diesem Gebiet/Land einen angemessenen
        Schutz der Rechte und Freiheiten natürlicher Personen in Bezug auf ihre
        personenbezogenen Daten bietet, werden wir diese Daten im Einklang mit
        den geltenden Datenschutzgesetzen übermitteln, unter anderem durch die
        Verwendung der von der EU-Kommission und/oder dem britischen
        Außenministerium (je nach Sachlage) genehmigten Standardvertragsklauseln
        (falls zutreffend). Sie können eine Kopie dieser
        Standardvertragsklauseln anfordern, wenn Sie uns wie unten beschrieben
        kontaktieren.
      </p>
      <p>
        Darüber hinaus verpflichten wir uns, sicherzustellen, dass wir alle
        zusätzlichen Anforderungen oder Leitlinien des Europäischen
        Gerichtshofs, des Datenschutzgesetzes und/oder der Aufsichtsbehörden in
        Bezug auf die Übermittlung personenbezogener Daten einhalten.
      </p>

      <h5 id='datenschutzrechte-von-bewerbern-in-kalifornien'>
        Datenschutzrechte von Bewerbern in Kalifornien
      </h5>
      <p>
        Das kalifornische Gesetz zum Schutz der Daten von Verbrauchern
        (California Consumer Privacy Act, „CCPA”) in der durch das kalifornische
        Datenschutzgesetz geänderten Fassung gewährt Bewerbern mit Wohnsitz in
        Kalifornien bestimmte Rechte in Bezug auf ihre Bewerberinformationen.
        Wenn Sie in Kalifornien ansässig sind, gilt dieser Abschnitt für Sie.
      </p>
      <p>
        Wir beziehen bzw. haben in den letzten 12 Monaten die in der
        nachstehenden Tabelle aufgeführten Kategorien von Bewerberinformationen
        erhoben, und zwar von Quellen, die im Abschnitt „Informationen, die wir
        erfassen” genannt werden. Einzelheiten zu den genauen Datenpunkten, die
        wir beziehen bzw. in den letzten 12 Monaten bezogen haben, finden Sie im
        vorstehenden Abschnitt „Informationen, die wir erfassen”. Die
        Bewerberinformationen werden von uns für die in der folgenden Tabelle
        aufgeführten geschäftlichen und kommerziellen Zwecke verwendet und
        weitergegeben, und wir geben diese Informationen an die Empfänger
        weiter, die ebenfalls in der folgenden Tabelle aufgeführt sind.
      </p>
      <Image
        src='/assets/img/legal/candidate-privacy-notice/candidate-information-table-de@2x.png'
        alt='Kandidaten informations tabelle'
        isLazy={false}
      />
      <p>
        Wir bewahren die Kategorien von Bewerberinformationen im Einklang mit
        den oben in{' '}
        <Link href='#unsere-aufbewahrungspraktiken-datenschutzerklärung-für-bewerber'>
          <a>Unsere Aufbewahrungspraktiken</a>
        </Link>{' '}
        beschriebenen Aufbewahrungspraktiken auf.
      </p>
      <p>
        Plaid (1) „verkauft” oder „teilt” (im Sinne der Definition dieser
        Begriffe im CCPA) keine Bewerberinformationen und (2) verwendet keine
        sensiblen personenbezogenen Daten für andere Zwecke als die in Paragraf
        1798.121(a) des CCPA angegebenen und gibt sie auch nicht für andere
        Zwecke weiter.
      </p>
      <p>
        Vorbehaltlich bestimmter Einschränkungen haben Sie das Recht, (a) mehr
        über die Quellen sowie die Kategorien und spezifischen Teile von
        Bewerberinformationen, die wir erheben, verwenden und weitergeben, und
        die Kategorien von Dritten, an die wir solche Informationen weitergeben,
        zu erfahren, (b) die Löschung von Bewerberinformationen zu verlangen,
        (c) die Korrektur ungenauer Bewerberinformationen zu verlangen und (d)
        wegen der Ausübung dieser Rechte nicht diskriminiert zu werden. Sie
        können diese Anträge stellen, indem Sie uns eine E-Mail an
        people-privacy@plaid.com senden, dieses{' '}
        <Link href='https://my.plaid.com/data-subject-request-form/'>
          <a>Webformular</a>
        </Link>{' '}
        ausfüllen oder unter der Nummer +1-415-799-1354 anrufen. Wir werden Ihre
        Anträge überprüfen, indem wir Sie bitten, uns Informationen zu Ihren
        kürzlich erfolgten Interaktionen mit uns zu liefern, wie z. B. Ihre
        Telefonnummer und E-Mail-Adresse. Wir werden Sie nicht unangemessen
        benachteiligen, wenn Sie Ihre Rechte aus dem CCPA ausüben.
      </p>
      <p>
        Wenn wir Ihren Antrag von einem bevollmächtigten Vertreter erhalten, der
        keine gültige Vollmacht vorlegt, können wir den Vertreter auffordern,
        den Nachweis dafür zu erbringen, dass Sie ihm eine unterzeichnete
        Erlaubnis erteilt haben, den Antrag zur Ausübung von Rechten in Ihrem
        Namen einzureichen. In Ermangelung einer gültigen Vollmacht können wir
        auch Sie auffordern, Ihre eigene Identität direkt bei uns zu
        verifizieren oder uns andernfalls zu bestätigen, dass Sie dem
        bevollmächtigten Vertreter die Erlaubnis erteilt haben, den Antrag
        einzureichen. Wenn Sie ein bevollmächtigter Vertreter sind, der einen
        Antrag stellen möchte, senden Sie uns bitte eine E-Mail an{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>
        .
      </p>

      <h5 id='datenschutzrechte-von-bewerbern-datenschutzerklärung-für-bewerber'>
        Datenschutzrechte von Bewerbern im UK, im EWR und in Kanada
      </h5>
      <p>
        Nach geltendem Recht stehen Ihnen bestimmte Rechte in Bezug auf Ihre
        Bewerberinformationen zu. Diese Rechte können je nach Land und Provinz
        variieren.
      </p>
      <p>
        Vorbehaltlich bestimmter Einschränkungen und Ausnahmen beinhalten diese
        Rechte das Recht auf Folgendes: (i) zu erfahren, ob wir personenbezogene
        Daten über Sie verarbeiten, (ii) Zugang zu den personenbezogenen Daten,
        die wir über Sie verarbeiten, oder deren Berichtigung zu verlangen,
        (iii) der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen
        oder zu verlangen, dass wir diese einschränken, (iv) zu verlangen, dass
        wir personenbezogene Daten über Sie löschen, (v) zu verlangen, dass wir
        die personenbezogenen Daten, die Sie uns zur Verfügung gestellt haben,
        in einem strukturierten, gebräuchlichen und maschinenlesbaren Format zur
        Übermittlung an einen anderen Verantwortlichen bereitstellen, (vi) die
        Einwilligung jederzeit zu widerrufen, wenn unsere Verarbeitung auf Ihrer
        Einwilligung beruht, und (vii) eine Beschwerde bei Ihrer lokalen
        Aufsichtsbehörde einzureichen (wenn Sie im UK ansässig sind, finden Sie
        auf dieser{' '}
        <Link href='https://ico.org.uk/global/contact-us/'>
          <a>Seite</a>
        </Link>{' '}
        die Kontaktangaben des Information Commissioner’s Office, und wenn Sie
        im EWR ansässig sind, finden Sie auf dieser{' '}
        <Link href='https://edpb.europa.eu/about-edpb/board/members_en'>
          <a>Seite</a>
        </Link>{' '}
        die Kontaktangaben der EU-Aufsichtsbehörden).
      </p>
      <p>
        Wenn Sie eines Ihrer Rechte ausüben möchten, kontaktieren Sie uns bitte
        unter den unten angegebenen Kontaktdaten.
      </p>
      <p>
        Außerdem geben wir Ihnen auf Wunsch gerne einen detaillierteren
        Überblick über unsere relevanten Verarbeitungszwecke (sowie die
        entsprechenden Datenkategorien, Aufbewahrungsfristen und rechtlichen
        Verarbeitungsgründe).
      </p>

      <h5 id='anderungen-an-dieser-erklärung-datenschutzerklärung-für-bewerber'>
        Änderungen an dieser Erklärung
      </h5>
      <p>
        Wir können diese Datenschutzerklärung für Bewerber von Zeit zu Zeit
        ändern. Wenn wir Änderungen vornehmen, aktualisieren wir das
        Gültigkeitsdatum oben in dieser Erklärung. Wenn eine der Änderungen
        wesentlicher Art ist und Auswirkungen auf Ihre Bewerberinformationen
        hat, senden wir Ihnen außerdem eine Kopie per E-Mail.
      </p>

      <h5 id='kontaktaufnahme-mit-plaid-datenschutzerklärung-für-bewerber'>
        Kontaktaufnahme mit Plaid{' '}
      </h5>
      <p>
        Wenn Sie Fragen zu dieser Datenschutzerklärung für Bewerber, unseren
        Datenschutzpraktiken oder den von uns über Sie erfassten
        Bewerberinformationen haben oder Anträge im Zusammenhang mit diesen
        Bewerberinformationen stellen möchten, können Sie uns per E-Mail an{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>{' '}
        oder per Post unter folgender Adresse kontaktieren:
      </p>
      <p>
        <em>
          Wenn Sie sich für eine Stelle bei Plaid Inc. (mit Sitz in den USA)
          bewerben:
        </em>
      </p>
      <p>
        Plaid Inc. <br />
        Attn: Legal <br />
        PO Box 7775 #35278 <br />
        San Francisco, Kalifornien 94120-7775, U.S.A.
      </p>
      <p>
        <em>
          Wenn Sie sich für eine Stelle bei Plaid Financial Ltd. (mit Sitz im
          UK) bewerben:
        </em>
      </p>
      <p>
        Plaid Financial Ltd. <br />
        Attn: Legal <br />
        New Penderel House, 4th Floor <br />
        283-288 High Holborn <br />
        London, Großbritannien, WC1V 7HP
      </p>
      <p>
        <em>
          Wenn Sie sich für eine Stelle bei Plaid, B.V. (mit Sitz in den
          Niederlanden) bewerben:
        </em>
      </p>
      <p>
        Plaid, B.V. <br />
        Attn: Legal <br />
        Muiderstraat 1 <br />
        1011 PZ Amsterdam, Niederlande
      </p>

      <hr className='section-divider' />
    </>
  );
};

propTypes.DeVersion = PropTypes;
export default DeVersion;
